import React from 'react';
import standImage from '../../../assets/images/dyslexia/stand_image.png';
import { motion } from 'framer-motion';
import { useMediaQuery } from 'react-responsive';
const MythTruth = () => {
  const isMobile = useMediaQuery({ query: '(max-width: 767px)' });
  return (
    <div className="w-full flex flex-col justify-between gap-4 max-w-[1200px] mx-auto px-4 md:px-10 py-10 md:py-20 relative">
      <h2 className="text-[38px] sm:text-[40px] md:text-[54px] text-primary font-bold leading-tight">
        Dispelling Common Myths About Dyslexia
      </h2>
      <h4 className="text-[32px] sm:text-[36px] md:text-[40px] text-[#7B54A2] font-bold leading-[40px] lg:leading-[50px]">
        It's important to separate fact from fiction when it comes to dyslexia:
      </h4>

      <div className="flex text-center items-center justify-center mt-10">
        <motion.div
          initial={{ opacity: 0, y: isMobile ? 0 : 300 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, ease: 'easeOut' }}
          viewport={{ once: true, amount: 0.5 }}
        >
          <img src={standImage} alt="Stand" className="w-[800px]" />
        </motion.div>
      </div>
    </div>
  );
};

export default MythTruth;
